import { Box, Center, Img, keyframes } from '@chakra-ui/react'
import LogoIcon from '../assets/wrk_logo.png'
import useWindowHeight from '../hooks/useWindowHeight'

const pulseRing = keyframes`
  0% {
    transform: scale(0);
    opacity: 0.7;
  }
  100% {
    transform: scale(2.4);
    opacity: 0;
  }
`

const Loading = () => {
  const windowHeight = useWindowHeight()

  return (
    <Center w="100%" h={`${windowHeight}px`} bg="white">
      <Box position="relative" display="flex" alignItems="center" justifyContent="center">

 
        <Center w='132px' h='132px' bg='white' borderRadius='full' zIndex='10000'>
          <Img src={LogoIcon} alt="Logo" width="110px" height="55px" alignSelf="center" zIndex={1}/>
        </Center>

        {/* Pulse rings */}
        <Box
          position="absolute"
          w="100px"
          h="100px"
          borderRadius="full"
          bg="primary.50"
          opacity={0.2}
          animation={`${pulseRing} 2.4s cubic-bezier(0.215, 0.61, 0.355, 1) infinite`}
        />
        <Box
          position="absolute"
          w="100px"
          h="100px"
          borderRadius="full"
          bg="primary.50"
          opacity={0.2}
          animation={`${pulseRing} 2.4s cubic-bezier(0.215, 0.61, 0.355, 1) infinite 0.6s`}
        />
        <Box
          position="absolute"
          w="100px"
          h="100px"
          borderRadius="full"
          bg="primary.50"
          opacity={0.2}
          animation={`${pulseRing} 2.4s cubic-bezier(0.215, 0.61, 0.355, 1) infinite 1.2s`}
        />


        {/* Logo */}

      </Box>
    </Center>
  )
}

export default Loading
